import { getFunctions, httpsCallable } from 'firebase/functions';
import { app } from '../config/firebase';

const ensureProfile = httpsCallable(getFunctions(app, 'us-central1'), 'suiteUserProfile');
export async function syncUserProfile() {
  const result = await ensureProfile();
  return result.data;
}

export function profileSyncMessage(error) {
  if (error.code === 'functions/not-found') return 'Profile setup is unavailable. Please try again later.';
  if (error.code === 'functions/unauthenticated') return 'Your session has expired. Please sign in again.';
  return 'Your profile has not synced yet. We will retry automatically.';
}

// Restored Firebase sessions enter here too; sign-in is not required to create a profile.
export function startProfileSync(onState) {
  let stopped = false;
  let pending = false;
  let timer;
  let failures = 0;
  async function sync() {
    if (stopped || pending) return;
    window.clearTimeout(timer);
    pending = true;
    onState({ syncing: true, error: null });
    try {
      const profile = await syncUserProfile();
      if (!stopped) {
        failures = 0;
        onState({ syncing: false, error: null, ...profile });
        timer = window.setTimeout(sync, 30000);
      }
    } catch (error) {
      if (!stopped) {
        onState({ syncing: false, error: profileSyncMessage(error) });
        if (error.code !== 'functions/unauthenticated') {
          timer = window.setTimeout(sync, Math.min(5000 * (2 ** failures++), 60000));
        }
      }
    } finally { pending = false; }
  }
  window.addEventListener('online', sync);
  window.addEventListener('focus', sync);
  sync();
  return {
    retry: sync,
    stop() {
      stopped = true;
      window.clearTimeout(timer);
      window.removeEventListener('online', sync);
      window.removeEventListener('focus', sync);
    },
  };
}
